import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { DEFAULT_LIST_QUERY_PARAM_LIMIT } from '../../../../../common/models';
import { ListQueryParam } from '../../../../../common/constants/list-query-param.constant';
import { PlantEndpoint } from '../../../../constants';

@Injectable({
  providedIn: 'root',
})
export class PlantOptionsService {
  constructor(private http: WrapperHttpService) {}

  getPlants(filter: string): Observable<string[]> {
    const url = `${API_URL}${PlantEndpoint.Search}${PlantEndpoint.Base}?${ListQueryParam.Limit}=${DEFAULT_LIST_QUERY_PARAM_LIMIT}&${ListQueryParam.Filter}=${filter}`;
    return this.http.withLoading().get<string[]>(url);
  }
}
